import './imports/jquery'
import Vue from 'vue'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Vuebar
import Vuebar from 'vuebar';
Vue.use(Vuebar);

//////////////////////////////////////////////////////////////// Cookies Message
import CookiesMsg from './plugins/cookies-msg/index.js'
Vue.use(CookiesMsg)

//////////////////////////////////////////////////////////////// Site Drawer
import SiteDrawer from './plugins/site-drawer/index.js'
Vue.use(SiteDrawer)

//////////////////////////////////////////////////////////////// Dropdown
import {
    DropdownPlugin
} from 'bootstrap-vue'
Vue.use(DropdownPlugin)

//////////////////////////////////////////////////////////////// Collapse (Accordion)
import {
    CollapsePlugin
} from 'bootstrap-vue'
Vue.use(CollapsePlugin)

//////////////////////////////////////////////////////////////// Gallery Lightbox
import galleryOptions from './imports/fancyOptions.js'
import FancyBox from './plugins/fancy-box/index.js'
Vue.use(FancyBox, galleryOptions)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -180,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Form validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/index.vue'
Vue.component('bgImage', BgImage)

//////////////////////////////////////////////////////////////// Cookies Bar
import CookiesBar from './components/cookies-bar/index.vue'
Vue.component('CookiesBar', CookiesBar)

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Sticky element
import Sticky from 'vue-sticky-directive/vue-sticky-directive.js'
Vue.directive('Sticky', Sticky);

/////////////////////////////////////////////////////////////////////////////////////////////////// FILTERS

//////////////////////////////////////////////////////////////// Currency
import VueCurrencyFilter from 'vue-currency-filter'

Vue.use(VueCurrencyFilter, {
    symbol: '€',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'back',
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
})

/////////////////////////////////////////////////////////////////////////////////////////////////// App Components
import StickyElement from './components/sticky-element/index.vue'
const BookWidget = () => import('./components/book-widget/index.vue')
const VillasCarousel = () => import('./villas-carousel.vue')
const VillasListing = () => import('./villas-listing.vue')
const VillaInner = () => import('./villa-inner.js')
// const VillaPricing = () => import('./villa-pricing.vue')
const LocationCategories = () => import('./location-categories.js')
const ServicesCategories = () => import('./services-categories.js')
const GallerySlider = () => import('./gallery-slider.vue')
// import ProductsCarousel from './products-carousel.vue'
const FaqsCategories = () => import('./faqs-categories.js')
const ContactForm = () => import('./contact-form.js')
const GoogleMap = () => import('./google-map.vue')

import {
    devices,
    // getParam
} from './imports/utils'

var app = new Vue({
    el: '#app',
    components: {
        StickyElement,
        BookWidget,
        VillasCarousel,
        VillasListing,
        VillaInner,
        // VillaPricing,
        LocationCategories,
        ServicesCategories,
        GallerySlider,
        FaqsCategories,
        ContactForm,
        GoogleMap
    },
    data() {
        return {
            lang: document.getElementById('app').getAttribute('lang'),
            isDevice: devices(),
            windowWidth: window.innerWidth,
            scrollTop: window.scrollY,
            showMap: false,
            showCookiesBar: true,
            // footerHeight: 0,
        }
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth
            // this.footerHeight = this.$refs['footer'].clientHeight + 50
        },
        onScroll() {
            this.scrollTop = window.scrollY
        },
        toggleMap() {
            this.showMap = !this.showMap
        },
        scrollTo(id) {
            this.$scrollTo(document.getElementById(id), 1000, {
                offset: -150,
            })
        }
    },
    created() {
        window.addEventListener("resize", this.onResize, {
            passive: false
        })

        window.addEventListener('scroll', this.onScroll, {
            passive: false
        })

        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;')
    },
    mounted() {
        if (this.$refs['cookies-bar']) {
            this.showCookiesBar = this.$refs['cookies-bar'].showCookiesBar;
        }
        // setTimeout(() => {
        //     this.footerHeight = this.$refs['footer'].clientHeight + 50
        // }, 200);
    },
    destroyed() {
        window.removeEventListener("resize")
        window.removeEventListener("scroll")
    }
})